import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { __ } from 'react-i18n';
import { getRequestDetailItemInfo } from '../../../utilities/selectors';
import { getZemplinRequestDetailItemInfo } from '../selectors';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexRow,
} from '../../Defaults/Flexbox/Flexbox';
import { OrderNr, Note } from './RequestDetailItemRow';
import { MobileTitleValue } from '../Cart/Items/MobileTitleValue';
import { getSymbolFromCurrency, formatPriceToString } from '../../../utilities';

export interface Props {
  item: any;
  theme: any;
  showMoreInfo: boolean;
}

function RequestDetailItemMobile({ item, theme, showMoreInfo }: Props) {
  const {
    ordernr,
    name,
    note,
    image,
    currency,
    totalPriceWithoutVat,
    unitprice,
  } = getRequestDetailItemInfo(item);
  const { count, unit } = getZemplinRequestDetailItemInfo(item);

  return (
    <Wrapper>
      <UpperWrapper>
        <Image alt={`Obrázok ku produktu ${name}`} src={image} />
        <NameInputWrapper>
          <Name>{name}</Name>
          <OrderNr>{ordernr}</OrderNr>
        </NameInputWrapper>
      </UpperWrapper>
      <PriceValuesWrapper>
        <MobileTitleValue
          title={__('Cena bez DPH')}
          value={formatPriceToString(unitprice, currency)}
        />
        <MobileTitleValue title={__('Množstvo')} value={`${count} ${unit}`} />
        <MobileTitleValue
          title={__('Spolu bez DPH')}
          value={formatPriceToString(totalPriceWithoutVat, currency)}
        />
      </PriceValuesWrapper>
      <StyledNote>{'bla bla'}</StyledNote>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ noBorderBottom: boolean }>`
  width: 100%;
  max-width: ${rem(320)};
  margin: 0 auto;
  border-bottom: ${({ noBorderBottom, theme }) =>
    !noBorderBottom ? theme.borders.primary : 'none'};
  padding: ${rem(24)} 0;

  &:first-child {
    border-top: ${({ theme }) => theme.borders.primary};
  }

  ${({ theme }) => theme.mediab.s450`
      margin: 0 -${rem(16)};
      padding:  ${rem(24)} ${rem(16)};
      max-width: initial;
      width: calc(100vw - ${rem(16)});
  `}
`;

const UpperWrapper = styled(FlexRow)`
  margin-bottom: ${rem(24)};
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: initial;
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(4)};

  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(400)};
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `}
`;

const PriceValuesWrapper = styled(FlexCol)`
  margin-bottom: ${rem(16)};
`;

const StyledNote = styled(Note)`
  font-size: ${rem(13)};
`;

const WithTheme: any = withTheme(RequestDetailItemMobile);
export { WithTheme as RequestDetailItemMobile };
